import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
  currentCliente: '',
  clienti: [],
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    aggiornaCurrentCliente(state, action) {
      state.currentCliente = action.payload;
    },

    aggiornaClienti(state, action) {
      state.clienti = _.uniq(action.payload);
    },
  },
});

export const { aggiornaClienti, aggiornaCurrentCliente } = globalSlice.actions;
const globalReducer = globalSlice.reducer;

export default globalReducer;
